/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// hide product_colors_set to hide the swatch if not showen START


// hide product_colors_set to hide the swatch if not showen END

// update klavyo notify me when avalible popup START

$('#klaviyo-bis-trigger').click(function(){

$('#klaviyo-bis-iframe').css('visibility','hidden');

  
    console.log(':::::::::::::',$('input[name="option-0"]:checked').val());
      var selected = $('input[name="option-0"]:checked').val();
  
  setTimeout(function(){
  
      var klaviyo_body = window.frames['klaviyo-bis-iframe'].contentDocument.body;
    
      $(klaviyo_body).find('#variants option[value="'+$('input[name="option-0"]:checked').attr('varint_id')+'"]').attr("selected",true);
    $('#klaviyo-bis-iframe').css('visibility','visible');
  }, 250);
})

// update klavyo notify me when avalible popup END


// company restrict to 25 charectors code start

$( document ).ready(function() {
  $('#address_form_new').submit(function (e) {
    
    if($('#company_name_add').val().length < 26){
    $(".company_error_new").hide();
      console.log("good to go");
    
      $('#address_form_new').unbind('submit');
    
    }else{
      e.preventDefault();
        $(".company_error_new").show();
      
       console.log("not goos to go");
    }
  });

  
  $('#company_name_add').focusout(function(){
      if($('#company_name_add').val().length < 26){
      $(".company_error_new").hide();
        console.log("good to go");
            
      }else{
      $(".company_error_new").show();  
        console.log("not goos to go");
      }
  });




    $("#company_name_add").on('keyup',function(event) {      
      var maxLength = $( this ).attr( "maxlength" );
      var curLength = $( this ).val().length;
  	var fieldError = "#error1";
    
      if (maxLength <= curLength)  
      {    
          var curLength = $( this ).val().length; 
          $(".company_error_new").show();
          $( this ).val($( this ).val().substring(0, maxLength-1));
      }else {
          $(this).css('background','none');
          $(".company_error_new").hide();
      }       		
  });
});





  

$( document ).ready(function() {
 $('.update_address_custom').submit(function (e) {
    $('.Modal').each(function(i, obj) {
            // console.log($(this).attr('aria-hidden'));
            
        if($(this).attr('aria-hidden') == 'false'){
            // console.log($(this).find('#company_name_update').val());
            // console.log($(this).find('#company_name_update').val().length);
            if($(this).find('#company_name_update').val().length < 26){
                $(this).find(".company_error_update").hide();
                $('.update_address_custom').unbind('submit');
            }else{
                    e.preventDefault();
                    $(this).find(".company_error_update").show();
            }   
        }
    });
  });
  
$('.company_name_update').focusout(function(){
    $('.Modal').each(function(i, obj) {
            // console.log($(this).attr('aria-hidden'));
            
        if($(this).attr('aria-hidden') == 'false'){
            // console.log($(this).find('#company_name_update').val());
            // console.log($(this).find('#company_name_update').val().length);
           
            if($(this).find('#company_name_update').val().length < 26){
                $(this).find(".company_error_update").hide();
                $('.update_address_custom').unbind('submit');
            }else{
              
                    $(this).find(".company_error_update").show();
            }   
        }
        
    });
  });
  

  $('.Modal').each(function(i, obj) {
    $(this).find(".company_name_update").on('keyup',function(event) {
           var maxLength = $( this ).attr( "maxlength" );
           var curLength = $( this ).val().length;
    
    if($(this).closest('.Modal').attr('aria-hidden') == 'false'){
        if (maxLength <= curLength){    
            console.log("ififiifififif");
            var curLength = $( this ).val().length; 
            $(this).find(".company_error_update").show();
            $( this ).val($( this ).val().substring(0, maxLength-1));
        }else {
            console.log("elseesleesle");
           $(this).find(".company_error_update").hide();
        }    
     }
    });
  });    

});

// company restrict to 25 charectors code End




function nostoCurrencyFormat(price){
  if(Shopify.currency.active == "EUR"){
      price = price.replace('€','');
      price = parseFloat(price);
      //price = price * 1.00038753;
      // price = Math.ceil(price).toFixed(2);
      price = Math.ceil(price);
      price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      price = '€'+price +',00 EUR';
      return price;
    }
    else if(Shopify.currency.active == "CHF"){
      price = price.replace('CHF','');
      price = parseFloat(price);
      price = price * 0.9896773325;
      // price = Math.ceil(price).toFixed(2);
      price = Math.ceil(price);
      price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      price = 'CHF '+price +'.00';
      return price;
    }
    else if(Shopify.currency.active == "AED"){
      // price = price.replace(',','.');
      // price = price.replace('AED','');
      // price = Math.ceil(price).toFixed(2);
      // price = price.replace(',','.');
      // price = "Dhs. " + price;
      return price;
    }
    else if(Shopify.currency.active == "PLN"){//console.log('PLN price', price, price * 1.00038753);
      price = price.replace('zł','');
      price = parseFloat(price);
      price = price * 0.9980618797;
      // price = Math.ceil(price).toFixed(2);
      price = Math.ceil(price);
      price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      price = price +',00 zł PLN';
      return price;
    }
     // else if(Shopify.currency.active == "HUF"){
     //      price = price.replace(',','');
     //      price = price.replace('.','');
     //      price = price.replace('HUF','');
     //      price = Math.ceil(price/10000)*100;
     //      price = price / 1000;                  
     //      price =  price + "00 FT" ;
     //       return price;
     //   }
    else{
      return price;
    }
}

function initNostoPDPBundleCurrencyFormat(){
   
}

function initNostoCartDrawerCurrencyFormat(){
  document.querySelectorAll('.Side_Cart_Nosto .CartItem__Price.Price').forEach(item => {
    let price = item.innerHTML;
    item.innerHTML = nostoCurrencyFormat(price);
  })
}

// for Klaviyo "Added to Cart" event
// window.addEventListener('load', function() {
var _learnq = window._learnq || [];
function addedToCart() {
  fetch(`${window.location.origin}/cart.js`)
  .then(res => res.clone().json().then(data => {
    var cart = {
      total_price: data.total_price/100,
      $value: data.total_price/100,
      total_discount: data.total_discount,
      original_total_price: data.original_total_price/100,
      items: data.items
    }
    if (item !== 'undefined') {
      cart = Object.assign(cart, item)
    }
    if (klAjax) {
        _learnq.push(['track', 'Added to Cart', cart]);
        klAjax = false;
    }
	
	setTimeout(() => { 
		const one = document.querySelector('#wrapper_custom_sidecart :nth-child(1)');
		
		var opacity = 0;
		var intervalID = setInterval(function(){
	  
			if (opacity < 1) {
				opacity = opacity + 0.1;
				//one.style.opacity = opacity;
			} else {
				clearInterval(intervalID);
			}
		}, 50);
	}, 50);
  }))
};
(function (ns, fetch) {
  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
      if (`${window.location.origin}/cart/add.js`
      	.includes(res.url)) {
        	addedToCart()
      }
    });
    return response
  }
}(window, window.fetch));
var klAjax = true;
var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
for (var i = 0; i < atcButtons.length; i++) {
    atcButtons[i].addEventListener("click", function() {
      if (klAjax) {
        _learnq.push(['track', 'Added to Cart', item]);
        klAjax = false;
      }
    })
}
// });

/*For Nosto To Add Product TO Cart*/
function custom_nosto_add_to_cart(skuId, quantity = 1, callback = false, algolia_trigger = false, position = false, queryId = false){
//   alert(queryId);
  if($.isNumeric(skuId)) {
     $('.cbb-recommendations-variant-select').removeClass('unselected-size');
  }
  else{
    $('.cbb-recommendations-variant-select').addClass('unselected-size');
    return false;
  }
  
  //Make AJAX Call
  jQuery.post("/cart/add.js", {
          quantity: quantity,
          id: skuId,
      }
  )
  .done(function(data) {
    
    $g.track({
        scope           : "basket",
        action          : "add",
        data            : { product_id: data.product_id, quantity: 1 }
    });

    // for Klaviyo "Added to Cart" event
    addedToCart();
     
    document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant:skuId,
          quantity: quantity,
        }
      }));
    
    if(callback && typeof callback == "function"){
    	callback();
    }
    
    setTimeout(function(){
		$('#custom-loader').remove();
      	$('.custom-margin-add-to-cart').removeClass('custom-margin-add-to-cart');
    }, 1000);
    
 
    
    return skuId;
  })
  .fail(function(response) {
   
    let resp = JSON.parse(response.responseText)

    alert(resp.description);

    setTimeout(function(){
		$('#custom-loader').remove();
      	$('.custom-margin-add-to-cart').removeClass('custom-margin-add-to-cart');
    }, 1000);
    
    return response.responseText;
  });
}
    
$(document).on('click', '.size-variants-custom .size-add-cart-custom.available', function(){
  	
  if($(this).hasClass('Button')){
    $(this).addClass('custom-margin-add-to-cart');
  }
  
    var skuId = $(this).attr('sku-id');
  	
  
  	$(this).prepend('<div id="custom-loader" class="css_loader"></div>');
	
  	custom_nosto_add_to_cart(skuId, quantity = 1);
  	
})

  

$( document ).ready(function() {

        var variable = $(".Cart_Drawer_HeadBlock").height();
        
        $('#sidebar-cart .Drawer__Content').css( { height: 'calc(100% - ' + variable + 'px)' } );


        
    
  
  
  $(window).on('scroll', function() {
   if($( window ).width() > 1007){
      if($('#Product__Images .Product__SlideItem--image').length <= 6){
        $('#boxraw-show-more').remove();
      } 
    }

   if ($('#boxraw-show-more').length == 1){
    var hT = $('#boxraw-show-more').offset().top,
        hH = $('#boxraw-show-more').outerHeight(),
        wH = $(window).height(),
        wS = $(this).scrollTop();
    }

    if (wS > (hT+hH-wH)){
      $('#boxraw-show-more').addClass('NowWork');
    }else{
      $('#boxraw-show-more').removeClass('NowWork');
    }
  });
 
  $("#boxraw-show-more").click(function(e){
    e.preventDefault();
    $(".cust-loadmore-images").toggleClass("cust-hide");
    if($(this).html() == 'Load more images'){
      $(this).html('Show less images');
    }
    else{
      $(this).html('Load more images');
    }
    return false;
  });
  
  if($( window ).width() > 1007){
    if($('#Product__Images .Product__SlideItem--image').length > 6){
      if ($('#boxraw-show-more').length == 1){
      var hT = $('#boxraw-show-more').offset().top,
          hH = $('#boxraw-show-more').outerHeight(),
          wH = $(window).height(),
          wS = $(this).scrollTop();
      }
  
      if (wS > (hT+hH-wH)){
        $('#boxraw-show-more').addClass('NowWork');
      }else{
        $('#boxraw-show-more').removeClass('NowWork');
      }
    } 
  }
  
});
//	SHOW AND HIDE EXTRA IMAGES PDP END



 
// Social sharing PDP START
    function copyFunction() {
      var inputDump = document.createElement('input'),
          hrefText = window.location.href;
      document.body.appendChild(inputDump);
      inputDump.value = hrefText;
      inputDump.select();
      document.execCommand('copy');
      document.body.removeChild(inputDump);
    }


 $('.Product_SocialSharing li.url').click(function() {
    $(this).find('.CopyIcon').hide();
    $(this).find('.CheckIcon').show();
  });
// Social sharing PDP END



// Social sharing /pages/summer-sale-faq START

   function copyFunction_page_sale() {
      var inputDump = document.createElement('input'),
          hrefText = 'https://eu.boxraw.com/pages/sale';
      document.body.appendChild(inputDump);
      inputDump.value = hrefText;
      inputDump.select();
      document.execCommand('copy');
      document.body.removeChild(inputDump);

      $('#copy_page_sale').text('Copied!');
     
      setTimeout(function() { 
           $('#copy_page_sale').text('Copy');
        }, 1500);
     
    }


// Social sharing /pages/summer-sale-faq END


           
$(document).ready(function() {
 
   $(window).scroll(function() {

     $('.Mobile_sticky_ATC span').html( $('.ProductForm__AddToCart span').text() );
    
     
     var scroll = $(window).scrollTop();
      if (scroll >= 70) {
          $("body").addClass("Page_Scrolled");
      }
    else {
      $("body").removeClass("Page_Scrolled");
      $("body").removeClass("Page_Scrolled_2");
    }
  });
let oldValue = 0;
let newValue = 0;
window.addEventListener('scroll', (e) => {
  newValue = window.pageYOffset;

    if ((oldValue < newValue ) && ( oldValue >= 100)) {
       
       $("body").addClass("Page_Scrolled_2");
       $("#shopify-section-header").addClass("is-scrolled--down").removeClass("is-scrolled--up"); 
       $(".CollectionToolbar--top").addClass("is-scrolled--down").removeClass("is-scrolled--up"); 
       $(".Account_Nav_Wrapper").addClass("is-scrolled--down").removeClass("is-scrolled--up"); 
       $(".ArticleToolbar").addClass("is-scrolled--down").removeClass("is-scrolled--up"); 
      $(".wishlist_alert").addClass("is-scrolled--down").removeClass("is-scrolled--up");
    }
    else if (oldValue > newValue) {
       
      $("#shopify-section-header").removeClass("is-scrolled--down").addClass("is-scrolled--up"); 
      $(".CollectionToolbar--top").removeClass("is-scrolled--down").addClass("is-scrolled--up"); 
      $(".Account_Nav_Wrapper").removeClass("is-scrolled--down").addClass("is-scrolled--up"); 
      $(".ArticleToolbar").addClass("is-scrolled--up").removeClass("is-scrolled--down"); 
      $(".wishlist_alert").addClass("is-scrolled--up").removeClass("is-scrolled--down");
    }
    
    oldValue = newValue;
  
  });

  
  
document.getElementsByTagName("BODY")[0].onresize = function() {
    $("#shopify-section-header").addClass("is-scrolled--up");
    $("#shopify-section-header").removeClass("is-scrolled--down");
   
};
  
//   PDP Popup/Mobile carousel START ***********************
    var breakpoint = window.matchMedia( '(min-width:1008px)' ); 
    var MobileSlider;
    var breakpointChecker = function() { 
    if ( breakpoint.matches === true ) {  
    $('#Product__Images .Product__SlideItem .Targ_popup').click(function() { 
      $('.PDP_POP_Slider').show();  
      $(".PDP_POP_Slider .Product__SlideItem").removeClass("cust-hide");
      $('.Product__SlideItem').addClass('swiper-slide');
      
      var Thumbnails = new Swiper(".PDP_POP_Thumb", {
        spaceBetween: 0,
        slidesPerView: 6, 
        allowTouchMove: false, 
        freeMode: true,
        direction: 'vertical', 
      });

      var PopupSlider = new Swiper ('.PDPSwiper', {
        spaceBetween: 10,
        slidesPerView: 1,  
        direction: 'vertical',
        loop: false,  
        navigation: {
          nextEl: ".popup-thumb-next",
          prevEl: ".popup-thumb-prev",
        },
        thumbs: {
          swiper: Thumbnails,
        },
        mousewheel: {
          invert: true,
        } 
      });
 
      
      // if (this.tagName == 'DIV')  {  
      //   var WindHeight = $(window).height(); 
      //   $('.PDPSwiper .zoomImg img').height(WindHeight); 
      //   $('.PDPSwiper').css('height','100%'); 
      //     var SlideImgWidth = $('.PDPSwiper').find('div[data-image-media-position="0"]').find('img').width(); 
      //     $('.PDPSwiper .zoomImg').width(SlideImgWidth);  
      // }
      
      if (this.tagName == 'VIDEO')  {   
        var clicked_image_id = $(this).attr('id');
        var clicked_image_id = clicked_image_id.replace(/\D/g, ''); // a string of only digits, or the empty string  
        var clicked_image_id = parseInt(clicked_image_id, 10); 
          
        $.str = $("#Media"+clicked_image_id).attr("data-image-media-position");
        $.myArr = $.str.split("/");  
        $.swipe = PopupSlider.slideTo(parseInt($.myArr[0]), false,false); 
        var WindHeight = $(window).height();  
        $('.PDPSwiper .zoomImg video').height(WindHeight);  
        $('.PDPSwiper').css('height','100%');   
        var contNmbr = $.myArr[0];  
        
        var SlideVidWidth = $('.PDPSwiper .Product__SlideItem:not(.Product__SlideItem__Video)').find('img').width(); 
        $('.PDPSwiper .zoomImg:not(.VideoWrapper)').width(SlideVidWidth);
        $('.PDPSwiper .zoomImg.VideoWrapper').width(SlideVidWidth); 
           
      }
      else{   
        var clicked_image_id = $(this).attr('id');
        var clicked_image_id = clicked_image_id.replace(/\D/g, ''); // a string of only digits, or the empty string
        var clicked_image_id = parseInt(clicked_image_id, 10);
 
    
  
        $.str = $("#Media"+clicked_image_id).attr("data-image-media-position");
        $.myArr = $.str.split("/"); 
        
        $.swipe = PopupSlider.slideTo(parseInt($.myArr[0]), false,false);
         
        var WindHeight = $(window).height(); 
        $('.PDPSwiper .zoomImg img').height(WindHeight);  
        $('.PDPSwiper').css('height','100%'); 
        var contNmbr = $.myArr[0]; 
        
        var SlideImgWidth = $('.PDPSwiper').find('div[data-image-media-position="'+contNmbr+'"]').find('img').width();
        $('.PDPSwiper .zoomImg:not(.VideoWrapper)').width(SlideImgWidth).css('opacity','0');
        var SlideVidWidth = $('.PDPSwiper .Product__SlideItem:not(.Product__SlideItem__Video)').find('img').width(); 
        $('.PDPSwiper .zoomImg.VideoWrapper').width(SlideVidWidth).css('opacity','0');
        
        setTimeout(function() { 
          var SlideImgWidth = $('.PDPSwiper').find('div[data-image-media-position="'+contNmbr+'"]').find('img').width();
          $('.PDPSwiper .zoomImg:not(.VideoWrapper)').width(SlideImgWidth).css('opacity','1');
          var SlideVidWidth = $('.PDPSwiper .Product__SlideItem:not(.Product__SlideItem__Video)').find('img').width(); 
          $('.PDPSwiper .zoomImg.VideoWrapper').width(SlideVidWidth).css('opacity','1');
        }, 600);
         
      }
       
    });   
        if ( MobileSlider !== undefined ) MobileSlider.destroy( true, true ); 
        $('button#boxraw-show-more').show();    
        $("#Product__Images .PDP_Mobile_Carousel").children().unwrap();
        $("#Product__Images .swiper-container").children().unwrap();
        $("#Product__Images .swiper-wrapper").children().unwrap(); 
        $("#Product__Images .swiper-pagination").remove();
        $("#Product__Images .swiper-button").remove();
        $("#Product__Images .swiper-notification").remove();
        $('.Product__SlideItem').removeClass('swiper-slide'); 
        $('.Product__SlideItem').removeAttr('style'); 
        $('.swiper-slide-duplicate').remove();
        return; 
      } else if ( breakpoint.matches === false ) { 
        $('button#boxraw-show-more').hide(); 
        $('#Product__Images').css('display','block'); 
        $("#Product__Images").children().wrapAll("<div class='PDP_Mobile_Carousel'></div>"); 
        $(".PDP_Mobile_Carousel").children().wrapAll("<div class='swiper-container gallery-top'></div>"); 
        $(".swiper-container").children().wrapAll("<div class='swiper-wrapper'></div>");
        $(".swiper-wrapper").after('<div class="swiper-pagination"></div>');
        $(".swiper-container").after('<div class="swiper-button-next swiper-button pdp-mobile-slider-next"></div><div class="swiper-button-prev swiper-button pdp-mobile-slider-prev"></div>');
        $('.Product__SlideItem').addClass('swiper-slide');
        $('.Product__Images .ProductItem__Label').insertBefore('#Product__Images .swiper-container');
        $('.preview__Btn.preview__Btn_desk').insertBefore('#Product__Images .swiper-container');
        return enableSwiper();            
      } 
  };
    
  var enableSwiper = function() { 
    var MobileSlider = new Swiper('.gallery-top', { 
      cssMode: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: true,
      },
      spaceBetween: 10, 
      navigation: {
        nextEl: '.pdp-mobile-slider-next',
        prevEl: '.pdp-mobile-slider-prev',
      },  
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      }, 
      //loop:true, 
    }); 

  };

    breakpoint.addListener(breakpointChecker); 
    breakpointChecker();
  
//   PDP Popup/Mobile carousel END ***********************
  
    $('.popup_close').click(function() {
      PopupClose(); 
    });

    $(document).keydown(function(e) {
      if (e.keyCode == 27) {
        setTimeout(function(){
          $('[data-action="close-search"]').trigger('click');
          $('[data-action="close-drawer"]').trigger('click');
          // $('#shopify-section-header').removeClass('bg-black');
          // $('#Search').attr('aria-hidden', 'true');
          
          $('.acs_auto_popup.acs_scroll').hide();
          $('html').removeClass('no-scroll');

          $('#Country_Select__popup').attr('aria-hidden', 'true');
        }, 100);
        
        PopupClose();
        var DesktopVideo = document.getElementById("Popuped_Video_Desktop");
        var MobileVideo = document.getElementById("Popuped_Video_Mobile");
        if(DesktopVideo){DesktopVideo.pause();}
        if(MobileVideo){MobileVideo.pause();}
      }    
	});
 
    $(".zoomImg").mousemove(function(e){
		zoom(e);
	});
    
    
  $(window).resize(function() {
    var WindHeight = $(window).height(); 
    $('.PDPSwiper .zoomImg img').height(WindHeight);
    $('.PDPSwiper .zoomImg video').height(WindHeight); 
    var SlideImgWidth = $('.PDPSwiper .Product__SlideItem:not(.Product__SlideItem__Video)').find('img').width();
    $('.PDPSwiper .zoomImg:not(.VideoWrapper)').width(SlideImgWidth);   
    $('.PDPSwiper .zoomImg.VideoWrapper').width(SlideImgWidth); 
  });
    
  
  $('.Product_SocialSharing .sharing_trig').click(function() {
    $(this).next('.sharingMenu').slideToggle();
  });

  $(".SidebarMenu__Nav .Linklist__Item .newsletter, .countrySlct_Switch").click(function(){
     $(".Drawer__Close").trigger("click");
  });

  $('a[href*="#"]:not(.Scroll_To_Next)').on('click', function (e) {
    e.preventDefault()
    $('html, body').animate(
      {
        scrollTop: $($(this).attr('href')).offset().top - 90,
      }, 800, 'linear')
  })

  $('.classes_back_btn a[href*="#"]').on('click', function (e) {
    e.preventDefault()
    $('html').animate(
      {
        scrollTop: $($(this).attr('href')).offset().top - 210,
      }, 0, 'linear')
  })
   
  $('ul.points_navigator li').click(function() {
    $('ul.points_navigator li').removeClass('active');
    $(this).addClass('active');
  });


 $('.Description_Tab .Collapsible__Button').attr('aria-expanded','true');
 $('.Description_Tab .Collapsible__Inner').css('height','auto');

jQuery(document).on('click', '.Nosto_Bundle_Section .BundleSlider_Trig',function() {
  //alert('1 testing');
   jQuery(this).toggleClass('Opened');
   jQuery('.Bundle_Slide_Content').slideToggle();
   jQuery('.Bundle_TotalRow').toggleClass('collapsed'); 
});

$('.SlideIt_to_ATC').click(function() {
  $('html, body').animate({
      scrollTop: $(".Product_Color_Row").offset().top -20
  }, 1000);
});
 
  
  $('.openRegForm').click(function() {
    $(this).closest('#sidebar-menu').find('.Drawer__Close').trigger('click'); 
    $('.Main_Registeration_Popup .loginForm').slideUp('slow'); 
    $('.Main_Registeration_Popup .registerForm').slideDown('slow');   
  }); 
  $('.openLogForm').click(function() {
    $(this).closest('#sidebar-menu').find('.Drawer__Close').trigger('click');  
    $('.Main_Registeration_Popup .registerForm').slideUp('slow');
    $('.Main_Registeration_Popup .loginForm').slideDown('slow');  
  }); 
  $('.register_switch').click(function(){
    $('.Main_Registeration_Popup .loginForm').slideUp('slow');
    $('.Main_Registeration_Popup .registerForm').slideDown('slow');
    $('.Main_Registeration_Popup .forgotForm').slideUp('slow'); 
  });
  $(document).on('click', ".login_switch", function(){
    $('.Main_Registeration_Popup .loginForm').slideDown('slow');
    $('.Main_Registeration_Popup .registerForm').slideUp('slow');
    $('.Main_Registeration_Popup .forgotForm').slideUp('slow'); 
  });
  $(document).on('click', ".forgot_switch", function(){
    $('.Main_Registeration_Popup .loginForm').slideUp('slow');
    $('.Main_Registeration_Popup .registerForm').slideUp('slow');
    $('.Main_Registeration_Popup .forgotForm').slideDown('slow'); 
  });
  $(document).on('click', ".Main_Registeration_Popup .Modal__Close", function(){
    $('.Main_Registeration_Popup .loginForm').hide();
    $('.Main_Registeration_Popup .registerForm').hide();
    $('.Main_Registeration_Popup .forgotForm').hide(); 
  });

     
  
  // IMR LAST ------
  
  $('.c_js_AddToCart').click(function(event) { 
     
    if ($('button.hand_wrap').length > 0){ 
    } else {
      SizeSlctChecking(event);
    }   
  }); 


  
  $('.shopify-payment-button').click(function(event) { 
    SizeSlctChecking(event);
  });

   
  $('#pre_order_model_button').click(function(event) { 
    SizeSlctChecking(event);
  });
    

  $(".SizeSwatch_Element input").change(function(){
    
    if($('input.SizeSwatch__Radio:checked').parent().hasClass("In_Stock") == true ){

           // $("#PDP_Button_with_Wishlist").css('margin-bottom','0px');	
       // $(".payment_button_disable").css('margin-top','0px');	
        
      // $(".PDP_Button_with_Wishlist").show();
      
      $('#pre_order_model_button').show();
       $("#pre_order_model_button").text("pre-order now");
    $('#pre_order_model_outofstock_button').hide();

      $(".ProductForm__AddToCart").removeAttr("style")
       
    }else{
      
      $(".ProductForm__AddToCart").css('color','black');	
      $(".ProductForm__AddToCart").css('background','white');	
      $("#PDP_Button_with_Wishlist").css('margin-bottom','12px');	
      	
      // $(".PDP_Button_with_Wishlist").hide();
    $('#pre_order_model_button').hide();
      
    $('#pre_order_model_outofstock_button').show();

      
     }
    
    
    $('.shopify-payment-button__button button').removeAttr('disabled');
    $('.shopify-payment-button__button').removeAttr('disabled');

     $('#pre_order_model_button').removeAttr('disabled');
    // $('#pre_order_model_button').text('PRE ORDER');
    
    
    $(".ProductForm__AddToCart span").text( "Add to cart" );
    $(".ProductForm__AddToCart").removeAttr('disabled'); 
    $('.SizeSwatchList').removeClass('size-select-error');
    $('.Sizing_labels').removeClass('color-red');

  
  
  }); 
    
  $(document).on('click', ".Mobile_sticky_ATC", function() {
 
    if($('.ProductForm__AddToCart').is(':visible') && $(".SizeSwatch_Element input").length <= 0 ){
      $('.ProductForm__AddToCart').trigger('click');
    }
    else if($('.ProductForm__AddToCart').is(':visible') && $(".SizeSwatch_Element input").is(":checked")){
      $('.ProductForm__AddToCart').trigger('click');
    }


    if($(".SizeSwatch_Element input").length >= 0 || ! $(".SizeSwatch_Element input").is(":checked")) {
   
      $('html, body').animate({
        
        scrollTop: $(".ProductForm__AddToCart").offset().top -280
        // scrollTop: $(".ProductMeta__PriceList").offset().top -20
      }, 1000);
    }  

    SizeSlctChecking(event); 
  });

    
  var panels = jQuery('.acc_content');
  panels.hide();
  var activePanel = jQuery(this).find(panels);

  jQuery('.acc_strip .acc_trig').click(function() {   
    jQuery('.acc_strip').hide();
    jQuery(this).parent('.acc_strip').show();
    jQuery(this).hide();
    activePanel.show();
    jQuery('.LogoutLink').hide();
  }); 
  jQuery('.Back_Trig').click(function() {   
    jQuery(this).parent().parent().hide();
    jQuery(this).closest('.acc_strip').find('.acc_trig').show();
    jQuery('.acc_content').hide();
    jQuery('.acc_strip').show();
    jQuery('.LogoutLink').show(); 
  }); 
  
  
  $(window).on('scroll', function() { 
    initializeStickyAddToCart(); 
  });

  function PopupClose() {
    $('.PDP_POP_Slider').hide();
    $('.Product__SlideItem').removeClass('swiper-slide');   
    $('.PDPSwiper').removeAttr('style');
  }

  function zoom(e){
    var x, y;
    var zoomer = e.currentTarget;
    if(e.offsetX) {
      offsetX = e.offsetX;
    } else {
      offsetX = e.touches[0].pageX;
    }

    if(e.offsetY) {
      offsetY = e.offsetY;
    } else {
      offsetX = e.touches[0].pageX;
    }
    x = offsetX/zoomer.offsetWidth*100;
    y = offsetY/zoomer.offsetHeight*100;
    zoomer.style.backgroundPosition = x+'% '+y+'%';
  }
  
  
  window.addEventListener('load', (event) => {
    $('.shopify-payment-button__button button').attr('disabled', 'disabled');
    $('.shopify-payment-button__button').attr('disabled', 'disabled');
  });

   
function SizeSlctChecking(event){ 
if($(".SizeSwatch_Element input").is(":checked") || $(".SizeSwatch").hasClass("is-selected") == true) {
   // alert("qwe");
    $('.SizeSwatchList').removeClass('size-select-error');
    $('.Sizing_labels').removeClass('color-red');


    
  }else{  
  // alert("123");
    event.stopImmediatePropagation();
    event.preventDefault();  

    $('.shopify-payment-button__button button').attr('disabled', 'disabled');
    $('.shopify-payment-button__button').attr('disabled', 'disabled');

    $('.ProductForm__AddToCart').attr('disabled', true);

   $('#pre_order_model_button').attr('disabled', true);
    
  if ($('button.gift_card').length > 0){
    $(".ProductForm__AddToCart span").text("SELECT AMOUNT"); 

  }else{
    
   if ($(".c_js_AddToCart")[0]){
    // Do something if class exists
        // $(".ProductForm__AddToCart span").text("SELECT SIZE");
           $(".ProductForm__AddToCart span.C_add_to_cart").text("SELECT SIZE");		
     $(".ProductForm__AddToCart span.C_add_to_cart").addClass("C_add_to_cart_sticky");
     $(".ProductForm__AddToCart span").addClass("C_add_to_cart_sticky");
    } 

     $("#pre_order_model_button").text("SELECT SIZE");
  }
    $('.SizeSwatchList').addClass('size-select-error');
    $('.Sizing_labels').addClass('color-red');
     
  }
} 
 	 	  $(".Parent_notify_me_when_avalible_sticky").click(function(){		
    $(".klaviyo-bis-trigger")[0].click();		
});
  function initializeStickyAddToCart(){
      if($('.c_js_AddToCart').is(':visible') || $('.ProductForm__AddToCart').is(':visible') || $('.OrderNow__Btn_Main').is(':visible') ){
        // $('.Mobile_sticky_ATC .C_add_to_cart_sticky').html( $('.c_js_AddToCart .C_add_to_cart').html() );
        $('.ProductForm__AddToCart').each(function() {
          if (isScrolledIntoView($(this))) {
            $('.Mobile_sticky_ATC').removeClass('show');
            
          } else {
             
            $('.Mobile_sticky_ATC').addClass('show');
          }
        });

        $('.OrderNow__Btn_Main').each(function() {
          if (isScrolledIntoView($(this))) {
            $('.Mobile_sticky_ATC_BR').removeClass('show'); 
          } else { 
            $('.Mobile_sticky_ATC_BR').addClass('show');
          }
        });
        
      }else if($('.c_js_AddToCart').is(':visible') == false || $('.ProductForm__AddToCart').is(':visible') == false){		
 		
             		
        $('#klaviyo-bis-trigger').each(function() {		
   		
          		
          if (isScrolledIntoView($(this))) {		
            $('.Parent_notify_me_when_avalible_sticky').removeClass('show');		
            	
          } else {		
           	
            $('.Parent_notify_me_when_avalible_sticky').addClass('show');		
          }		
          		
        });		
      }
      else if($('#black-card-member-only-btn').is(':visible')){
        $('.Mobile_sticky_ATC .C_add_to_cart_sticky').html('SIGN IN TO BUY');
        $('#black-card-member-only-btn').each(function() {
          if (isScrolledIntoView($(this))) {
            $('.Mobile_sticky_ATC').removeClass('show');
            
          } else {
             
            $('.Mobile_sticky_ATC').addClass('show');
          }
        });
      }
      else if($('#cust-hand-made').is(':visible')){
        $('.Mobile_sticky_ATC .C_add_to_cart_sticky').html('ADD TO CART');
        $('#cust-hand-made').each(function() {
          if (isScrolledIntoView($(this))) {
            $('.Mobile_sticky_ATC').removeClass('show');
           
          } else {
            
            $('.Mobile_sticky_ATC').addClass('show');
          }
        });
      }
      else if($('#cust-pre-order').is(':visible')){
        $('.Mobile_sticky_ATC .C_add_to_cart_sticky').html('PRE-ORDER NOW');
        $('#cust-pre-order').each(function() {
          if (isScrolledIntoView($(this))) {
            $('.Mobile_sticky_ATC').removeClass('show');
            
          } else {
            
            $('.Mobile_sticky_ATC').addClass('show');
          }
        });
      }
      else{
        $('#cust-pre-order').each(function() {
          if (isScrolledIntoView($(this))) {
            $('.Mobile_sticky_ATC').removeClass('show');
            
          } else {
           
            $('.Mobile_sticky_ATC').addClass('show');
          }
        });
      }
    }

    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height(); 
      return ((elemBottom < (docViewBottom + 1)) && (elemTop > docViewTop));
    }


 

  
  
});
  




    

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



  
document.getElementById('dot').style.display = 'none';
   

 
// Show left inventory on vriant base START
      (function() {
        $(".SizeSwatch__Radio").on("change", function() { 

// $(".Mobile_sticky_ATC").text("ADD TO CART");
                                           
          $.click_value = $(this).val();
          
//           alert($(this).val());
          
          types = [];
          inventory = [];
          indexArr = [];
          
          $(".variant_option").each(function() {
            inventory.push($(this).attr("inventory"));
            types.push($(this).val());
          }); 
          
          $.index = types.indexOf($.click_value);

          for(var i=0; i<types.length; i++) {
            indexArr.push(inventory[$.index]);
          }  
          
          
 
          
          
          if((indexArr[0] < 6) && (indexArr[0] > 0)){
            
            $("#stock_level").show();

            $("#stock_level").text("Only "+indexArr[0]+" left in stock");
 
          }else{
 
          $("#stock_level").hide();

 
            $("#stock_level").text(" ");
          }
        });
      })();
      // Show left inventory on vriant base END


// CART black card calculation START


// CART black card calculation END

function isFacebookApp() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
} 

// regiter uer START
/*
$(document).on('click', '.Form__Submit_Register', function(){

  $('#form-loader-custom').show();
  var form = $('#create_customer_custom');
  //var url = form.attr('action');

//   alert("asdas");
  
  
  $.ajax({
    type: "POST",
    dataType:"json",
    url: 'https://journal.boxraw.com/customer_registration_private_app_dev/Eu/register_customer',
    data: form.serialize(),
    success: function(data)
    {
       

      if(data.errors){
        $('.Form__Alert.Alert.Alert--error').show();
        $('.Alert__ErrorList').html('');
        if(data.errors.first){
          $('.Alert__ErrorList').append('<li class="Alert__ErrorItem">First '+data.errors.first[0]+'</li>');
        }
        if(data.errors.last){
          $('.Alert__ErrorList').append('<li class="Alert__ErrorItem">Last '+data.errors.last[0]+'</li>');
        }
        if(data.errors.email){
          $('.Alert__ErrorList').append('<li class="Alert__ErrorItem">Email '+data.errors.email[0]+'</li>');
        }
        if(data.errors.password){
          $('.Alert__ErrorList').append('<li class="Alert__ErrorItem">Password '+data.errors.password[0]+'</li>');
        }
        if(data.errors.customer_tag){
          $('.Alert__ErrorList').append('<li class="Alert__ErrorItem">'+data.errors.customer_tag[0]+'</li>');
        }
        if(data.errors.accepts_marketing){
          $('.Alert__ErrorList').append('<li class="Alert__ErrorItem">'+data.errors.accepts_marketing[0]+'</li>');
        }
        $('#form-loader-custom').hide();
      }
      else{
        jQuery.ajax({
          type: 'POST',
          url: 'https://eu.boxraw.com/account/login',
          data: {"form_type": "customer_login",    "customer[email]": $('#email').val(),    "customer[password]": $('#password').val()},
          dataType: 'json',
          success: function(response) {
            
          }
        })
        setTimeout(function(){
          if(getParameterByName('return_to')){
            window.location.href = getParameterByName('return_to');
          }
          else{
            window.location.href = 'https://eu.boxraw.com/account?bc_register=true';
          }
        }, 3000);
      }
    }
  });
})
*/
// regiter uer END



//   on click change tabs on account page START
function openCity(evt, linkName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(linkName).style.display = "block";
  evt.currentTarget.className += " active";
}
//   on click change tabs on account page END




//   on redirect account from sub-pages START 
$(document).ready(function() {

  
  $(document).on('click', '.update_address_button', function(){               
    if (typeof (history.pushState) != "undefined") { 
      obj = { Title: "Test", Url: 'https://boxraw.com/account?fromaccountenter=true' }; 
      history.pushState(obj, obj.Title, obj.Url); 
    }                      
  });
  
  
  
  
  
  
  if(getParameterByName("viewreturn") == "true"  || getParameterByName("page") != null){

    $('#Acc_tabs li:nth-child(2)').addClass('active');
    $('#Acc_tabs li:nth-child(1)').removeClass('active');
    $('#Acc_tabs li:nth-child(3)').removeClass('active');
    $('#orders_link').css('display','block');
    $('#black_card_link').css('display','none');

  }else if(getParameterByName("fromaccountenter") == "true"){

    $('#Acc_tabs li:nth-child(4)').addClass('active');
    $('#Acc_tabs li:nth-child(1)').removeClass('active');
    $('#Acc_tabs li:nth-child(2)').removeClass('active');
    $('#settings_link').css('display','block');
    $('#tab_settings_address').css('display','block');   
    $('#black_card_link').css('display','none');
    $('.acc_strip_custom_hide').css('display','none');
    $('.logout-custom').css('display','none');

  }
  else{
    $('#Acc_tabs li:first').addClass('active');
    $('.tabContent').hide();
    $('.tabContent:first').show();
  }
});


$(".update_address_button").click(function(){

  setCookie("fromaccountenter","true");
});

if(getCookie("fromaccountenter") == "true"){

  setCookie("fromaccountenter",null)

  window.location.replace("https://eu.boxraw.com/account?fromaccountenter=true");

}

//   on redirect account from sub-pages END 

 

$(document).on('click', "#ReviewsWidget .R-RatingStars", function() {
  $('html, body').animate({
    scrollTop: $(".R-TabControls__item").offset().top
  }, 1000);
});

$(document).on('click', ".ruk_rating_snippet", function() {
  $('html, body').animate({
    scrollTop: ($("#Reviews_Collapsible").offset().top - 50)
  }, 1000);
});

var snippet = document.querySelectorAll(".ruk_rating_snippet");
for(var i=0;i<snippet.length;i++) {
  snippet[i].onclick = function(event) {
    event.preventDefault();

  }
}

 
 
// Back In Stock Modal START -----

 var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "Yq8bnp",
      list: 'RpsnHj',
      platform: "shopify"
    });
    klaviyo.enable("backinstock",{ 
    trigger: {
      product_page_text: "Notify Me When Available", 
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
     additional_styles: "@import url('//eu.boxraw.com/cdn/shop/t/170/assets/theme.css?v=2247042675198529511769624661');@import url('https://fonts.googleapis.com/css2?family=Antonio:wght@100;200;300;400;500;600;700&family=Inter:wght@100;200;300;400;500;600;700;800;900&family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&display=swap');",
     headline: "{product_name}",
     body_content: "Register to receive a notification when this item comes back in stock.",
     email_field_label: "Email",
     newsletter_subscribe_label: "Add me to your email list",
     subscribe_checked: true,
     button_label: "Notify me when available", 
     subscription_success_label: "You're in! We'll let you know when it's back.",
     footer_content: '',
     drop_background_color: "#000",
     //background_color: "#fff",
     //text_color: "#222",
     //button_text_color: "#fff",
     //button_background_color: "#000",
     //close_button_color: "#ccc",
     error_background_color: "#fcd6d7",
     error_text_color: "#C72E2F",
     success_background_color: "#d3efcd",
     success_text_color: "#1B9500"
    }
  });

// Back In Stock Modal END -----

// account page refer a friend copy code START ----- 

function copyToClipboard(refCodeValue, copyButton) {
    el = `.${refCodeValue}`;
    // resolve the element
    el = (typeof el === 'string') ? document.querySelector(el) : el;

    // handle iOS as a special case
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {

      // save current contentEditable/readOnly status
      var editable = el.contentEditable;
      var readOnly = el.readOnly;

      // convert to editable with readonly to stop iOS keyboard opening
      el.contentEditable = true;
      el.readOnly = true;

      // create a selectable range
      var range = document.createRange();
      range.selectNodeContents(el);

      // select the range
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      el.setSelectionRange(0, 999999);

      // restore contentEditable/readOnly to original state
      el.contentEditable = editable;
      el.readOnly = readOnly;
    }
    else {
      el.select();
    }

    // execute copy command
    try {
      document.execCommand('copy');
      btn = `.${copyButton}`;
      $(btn).find('span').html('Copied <i class="fa fa-check"></i>');
      setTimeout(function () {
        $(btn).find('span').html('Copy');
      }, 3000)
    } catch (e) {
    }
  }

// account page refer a friend copy code END ----- 


 
function openReviewTab() {
      var change = document.getElementById("Reviews_Collapsible_Inner")
      change.style.height = 'auto';
      change.style.overflow = 'visible';
      var x = document.getElementById("Reviews_Collapsible").getAttribute("aria-expanded"); 
      if (x == "false") {
        x = "true" 
      } 
      document.getElementById("Reviews_Collapsible").setAttribute("aria-expanded", x);
      $('html, body').animate({
        scrollTop: $(".reviews-combined-widget").offset().top-230
      }, 1000)
      var widget = document.querySelectorAll('.reviews-combined-widget');
  
    }; 

    var snippet = document.querySelectorAll(".ruk_rating_snippet");
    for(var i=0;i<snippet.length;i++) {
      snippet[i].onclick = function(event) {
        event.preventDefault();

      }
    }

// open review tab PDP END

 


// AC code Start ============================================================


// Collection Page Code IMR START =======================================

  $(document).on('click', '.SB_Filter_Header', function(e) {
    $(this).next('.SB_Filters_List').slideToggle();
    $(this).parent('.SB_Filter_Block').toggleClass('collapsed'); 
  });

  $(document).on('click', '.CollectionToolbar__LayoutType', function(e) {
    $('.CollectionToolbar__LayoutType').removeClass('is-active');
    $(this).addClass('is-active');  
    if($(this).attr('data-count') == '1') {
      $('.ProductListWrapper .ProductList > div').removeAttr('class').addClass('Grid__Cell 1/4--desk 1/3--tablet-and-up 1/1--phone');
    }
    else if($(this).attr('data-count') == '2') {
      $('.ProductListWrapper .ProductList > div').removeAttr('class').addClass('Grid__Cell 1/2--phone 1/2--desk 1/2--tablet-and-up');
    }
    else if ($(this).attr('data-count') == '4') {
      $('.ProductListWrapper .ProductList > div').removeAttr('class').addClass('Grid__Cell 1/2--phone 1/4--desk 1/3--tablet-and-up');
    }  
  });

  $(document).on('click', ".CollectionToolbar__Item--filter.CollectionToolbar__Item", function() {
    $('html').addClass('no-scroll').css('padding-bottom','0');
    var currentWinHeight = $(window).outerHeight();
    $('.CollectionInner .CollectionInner__Sidebar').addClass('SB_Filters_Show');
    $('.CollectionInner .CollectionInner__Sidebar').css('max-height',currentWinHeight);
    $('.PageOverlay').addClass('is-visible');
  });

  $(window).resize( function() { 
    var currentWinHeight = $(window).outerHeight();
    $('.CollectionInner .CollectionInner__Sidebar').css('max-height',currentWinHeight);
  });

  $(document).on('click', ".PageOverlay", function() {
    $('html').removeClass('no-scroll').css('padding-bottom','0');
    $('.CollectionInner .CollectionInner__Sidebar').removeClass('SB_Filters_Show');
    $('.PageOverlay').removeClass('is-visible');
  });
  $(document).on('click', ".SB_Filters_Close,.Drawer__Close", function() {
    $('html').removeClass('no-scroll').css('padding-bottom','0');
    $('.CollectionInner .CollectionInner__Sidebar').removeClass('SB_Filters_Show');
    $('.PageOverlay').removeClass('is-visible');
  });

function removeItemAll(arr, value) {
  var i = 0;
  while (i < arr.length) {
    if (arr[i] === value) {
      arr.splice(i, 1);
    } else {
      ++i;
    }
  }
  return arr;
}

$(document).on('click', '.ProductListWrapper .Horizontal_Filters.sizes a', function(e){
  e.preventDefault();
    var sizes = [];
    $('.Horizontal_Filters.sizes span').each(function(){
      if($(this).hasClass('active')){
        sizes.push($(this).find('a').html().toLowerCase());
      }
        
    })

  if($(this).parent('span').hasClass('active')){
    removeItemAll(sizes, $(this).html().toLowerCase());
  }
  else{
    sizes.push($(this).html().toLowerCase());
  }

  var t = '';
  
  if(sizes.length==0){
    
  }
  else{
    removeItemAll(sizes, 'clear all');
    
    $(sizes).each(function(index, value){
      t += 'stock-size='+value+'&'
    })
  }
  console.log(sizes);
  console.log(t);
  
  if($(this).html().toLowerCase() == 'clear all'){
    t='';
  }
    
  t = window.location.pathname + '?' + t;
    
  history.pushState(null, null, t);
  graphenehc.reload();
})
 
$(document).on('click', '.Horizontal_Filters_Row .Horizontal_Filters.products a', function(e){
  e.preventDefault();
  
  	let t = $(this).html().replace(' ', '-').toLowerCase();
  
  	let urlParams   = new URLSearchParams(window.location.search);
    urlParams.delete("filter-product");
    history.pushState(null, null, `${window.location.pathname}?${urlParams.toString()}`);
  
  if(t == 'all'){
    
  }
  else{   
	
    urlParams.set("filter-product", t);
    history.pushState(null, null, `${window.location.pathname}?${urlParams.toString()}`);
  }
  graphenehc.reload();
})

 
function get_prev_page() {
    // next few lines are purely an example,
    // here we encode the current page into the results
    // and then read most recent results to get latest page
    let prevPage = 1;
    document.querySelectorAll(".ProductList.ProductList--grid").forEach(function (div) {
 
        const pg = div.dataset.page_prev;
 
        if (pg) prevPage = parseInt(pg) - 1;
    });
//   alert(prevPage);
  if(prevPage > 0){	//alert(prevPage);
    	// this is the call to graphene
      graphenehc.load_page({
          page_number	: prevPage,
          set_page_url: true,
  //       	format		: "json",
          init: function (resp) {
  
          },
          success: function (response) {
  
            if(response.templates.category){
              $(".ProductList.ProductList--grid").prepend($(response.templates.category.html).find(".ProductList.ProductList--grid").html());

              $(".pagination-from").html($(response.templates.category.html).find(".pagination-from").html());
//               $(".pagination-total").html($(response.templates.category.html).find(".pagination-total").html());
            }
            else if(response.templates.search){
              $(".ProductList.ProductList--grid").prepend($(response.templates.search.html).find(".ProductList.ProductList--grid").html());

              $(".pagination-from").html($(response.templates.search.html).find(".pagination-from").html());
//               $(".pagination-total").html($(response.templates.search.html).find(".pagination-total").html());
            }

            $(".ProductList.ProductList--grid").attr('data-page_prev', prevPage);

            $('#boost-pfs-filter-tree2').hide();

            $('.Preloader_Content_Products').remove();

            collectionLoopProductsOnlyLoadMore();
            convertCurrencyBXRW();

              // custom code goes here – e.g. update progress
              let template = response.templates.category || response.templates.search;
              let progress = Math.min(template.current_page * template.page_size, template.count);//alert(progress);
              if (progress <= 48) {
                  // no more paging required
                  $('.loadPrev-ac-button').hide();
              }
          }
      });
  }
  else{
    $('.loadPrev-ac-button').hide();
  }
}

function get_next_page() {
    // next few lines are purely an example,
    // here we encode the current page into the results
    // and then read most recent results to get latest page
    let nextPage = 1;
    document.querySelectorAll(".ProductList.ProductList--grid").forEach(function (div) {
 
        const pg = div.dataset.page;
 
        if (pg) nextPage = parseInt(pg) + 1;
    });
    // this is the call to graphene
    graphenehc.load_page({
        page_number	: nextPage,
        set_page_url: true,
//       	format		: "json",
        init: function (resp) {
 
        },
        success: function (response) {
 
          if(response.templates.category){
         	$(".ProductList.ProductList--grid").append($(response.templates.category.html).find(".ProductList.ProductList--grid").html());
            
            $(".pagination-to").html($(response.templates.category.html).find(".pagination-to").html());
//             $(".pagination-total").html($(response.templates.category.html).find(".pagination-total").html());
          }
          else if(response.templates.search){
            $(".ProductList.ProductList--grid").append($(response.templates.search.html).find(".ProductList.ProductList--grid").html());
            
            $(".pagination-to").html($(response.templates.search.html).find(".pagination-to").html());
//             $(".pagination-total").html($(response.templates.search.html).find(".pagination-total").html());
          }
          
          $(".ProductList.ProductList--grid").attr('data-page', nextPage);
          
          $('#boost-pfs-filter-tree2').hide();
      	
          $('.Preloader_Content_Products').remove();

          collectionLoopProductsOnlyLoadMore();
          convertCurrencyBXRW();
          
            // custom code goes here – e.g. update progress
            let template = response.templates.category || response.templates.search;
            let progress = Math.min(template.current_page * template.page_size, template.count);
            if (progress == template.count) {
                // no more paging required
              	$('.loadMore-ac-button').hide();
            }
        }
    });
}


// Collection Page Code IMR END =======================================
 



initNostoRecSliderUpdated();
 

var swiper = new Swiper('.TabsBannerSlider', { 
  cssMode: true,  
  //loop:true, 
  navigation: {
    nextEl: ".tabs-slider-next",
    prevEl: ".tabs-slider-prev",
  },
}); 

var swiperZ = new Swiper('.Blog_Posts_Slider', {
  //cssMode: true, 
  spaceBetween: 10, 
  //loop:true, 
  breakpoints: {  
    1024: {
      slidesPerView: 3, 
    },
    768: { 
      slidesPerView: "auto",
      cssMode: true,
    },
    500: {
      slidesPerView: "auto",
    },
    300: {
      slidesPerView: "auto",
    },
  },   
  navigation: {
    nextEl: '.posts-slider-next',
    prevEl: '.posts-slider-prev',
  }, 
});

$('.Modal__Close').click(function() {
$(this).closest('.Modal').attr('aria-hidden','true');
});

$(document).on("click",".Tabs_Banners_Section .TabList__Item",function() { 
  var TargBlock = $(this).attr('aria-controls');
  $('.TabList__Item').removeClass('is-active');
  $(this).addClass('is-active');
  $('.TabPanel').attr('aria-hidden','true');
  $('#'+TargBlock).attr('aria-hidden','false');
});


function PlayFunctionD(Popuped_Videos) {   
  var DesktopVideo = document.getElementById("Popuped_Video_Desktop"); 
   DesktopVideo.play(); 
};
function PlayFunctionM(Popuped_Videos) {    
  var MobileVideo = document.getElementById("Popuped_Video_Mobile"); 
   MobileVideo.play(); 
};

$('.Popup_Video_Section .Modal__Close').click(function() {
  var DesktopVideo = document.getElementById("Popuped_Video_Desktop");
  var MobileVideo = document.getElementById("Popuped_Video_Mobile");
   DesktopVideo.pause();
   MobileVideo.pause();
});
  
// Mobile ATC styling START FOR AB TEST prep ============================================ 
$(document).on('click', '.Mobile_ATC_Btn', function(e) {
  $('html').addClass('no-scroll').css('padding-bottom','0');
  $('.PageOverlay_For_m_atc').addClass('is-visible');
  
  var svc = $(this).parent().find('.size-variants-custom').html(); 
  $('.quick_add_popover_content .size-variants-custom').html(svc); 
  var targPopover = $(this).attr('aria-controls');
  $('#'+targPopover).attr('aria-hidden','false');
  e.stopPropagation();
});
$(document).on("click","#quick_add_popover .Popover__Close",function() {
  var targPopover = $(this).closest('.Popover').attr('id');
  $('#'+targPopover).attr('aria-hidden','true');
  $('.PageOverlay_For_m_atc').removeClass('is-visible');
  $('html').removeClass('no-scroll');
}); 
 
 
$(document).on("click",".PageOverlay_For_m_atc, .quick_add_popover_content .size-add-cart-custom.available ",function() {
$('#quick_add_popover').attr('aria-hidden','true');
$('.PageOverlay_For_m_atc').removeClass('is-visible');
  $('html').removeClass('no-scroll');
});
// Mobile ATC styling END FOR AB TEST prep ============================================ 





//Quick Search UI/UX New Experience START ===================
$('.Search__Input').on('blur', function(){ 
   $('.Search__Input_Placeholder').removeClass('focused');
}).on('focus', function(){
  $('.Search__Input_Placeholder').addClass('focused'); 
});

$(document).on('keyup','.Search__Input',function(){ 
  var input = $(this); 
  if( input.val() == "" ) {
    $('.Search__Input_Placeholder').show(); 
    $(this).addClass('Search__input_hide_caret'); 
  }  
  else {
     $('.Search__Input_Placeholder').hide(); 
     $(this).removeClass('Search__input_hide_caret'); 
  }
});

$('[data-action="toggle-search"]').click(function() {
  $('.Search__Input').addClass('Search__input_hide_caret');
  $('.Search__Input_Placeholder').show();
});

jQuery(document).ready(function($){
var deviceAgent = navigator.userAgent.toLowerCase();
var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);
    if (agentID) { 
	$('html').addClass('ios-browser'); 
    }
});
 
//Quick Search UI/UX New Experience END ===================

  // /////////////////////////////////////////////  cart preloader START
 const myTimeout = setTimeout(function(){
    $("#reviewsio-carousel-widget").show();
     $("#CartPage_Reviews_Preloaders").hide();
    
}, 2500);
 // /////////////////////////////////////////////  cart preloader END
 
// BIL Landing Page Code START =================================================================
jQuery(document).ready(function($){  
  $('.Bil_VideoBanner_Content .Scroll_To_Next').on('click', function (e) {
    e.preventDefault()
     $('html , body').animate(
      {
        scrollTop: $($(this).closest('.shopify-section').next('.shopify-section')).offset().top,
      }, 500, 'linear')
 
  })
});

$( window ).on( "load", function() { 
  $(".CreedLanding_klaviyo_Preloader").hide(); 
  $(".Creed_VideoBanner_Signup .klaviyo-form").show(); 
  
  $(".PDP_ComingSoon_klaviyo_Preloader").hide(); 
  $(".custom-coming-soon-form-block .klaviyo-form").show(); 
});



$(".BoxingBag_StickyBtn").click(function() {
    $('html,body').animate({
        scrollTop: $(".Meta_Colors_Group").offset().top -90
    },'700');
});
